import { composeIO } from 'react-compose-io'
import { tabelaContabilizacaoIO } from './TabelaContabilizacao.IO'
import { TabelaContabilizacaoView } from './TabelaContabilizacao.View'

export const TabelaContabilizacao = composeIO(TabelaContabilizacaoView, tabelaContabilizacaoIO)
